/* eslint-disable arrow-body-style */
import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';
import type {
  BudgetTrendType,
  HeadcountType,
  ForecastYearType,
  IPageInfoFetchParams,
  IPageInfo,
  IDateInfo,
  IKeyMetricsInfoFetchParams,
  IKeyMetricsInfo,
  IBudgetPieInfoFetchParams,
  IBudgetPieInfo,
  IBudgetPieInfoDownloadParams,
  IEventHistoryInfoFetchParams,
  IEventHistoryInfo,
  IEventHistoryInfoDownloadParams,
  IMilestoneFetchParams,
  IAddEventParams,
  IDevBudgetChangeDTO,
  IDevBudgetDataDTO,
} from '@gp/types/finance';

/**
 * 获取页面级数据
 * @param params 入参
 * @returns 页面级数据
 */
export function fetchPageInfo(params: IPageInfoFetchParams): Promise<IPageInfo> {
  return http.get('', { params });
}

export const queryBudgetTrend = (params: BudgetTrendType): Promise<any> => {
  return http.get('/api/v1/globalpedia_pc/finance/BudgetTrend', {
    params,
  });
};

export const downloadTrend = (
  params: BudgetTrendType | HeadcountType | ForecastYearType,
): Promise<any> => {
  // @ts-ignore
  return http({
    url: '/api/v1/globalpedia_pc/finance/trendDownload',
    method: 'GET',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const fetchApprovedTotalDevBudgets = (params: {
  project_id: string;
}): IBaseResponse<{ list: IDevBudgetChangeDTO[] | null; }> => {
  return http({
    url: '/api/v1/globalpedia_pc/finance/dev_budget_by_milestone',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

export const downloadApprovedTotalDevBudgets = (params: {
  project_id: string;
  file_type: string;
}) => {
  return http({
    url: '/api/v1/globalpedia_pc/finance/dev_budget_by_milestone_download',
    method: 'GET',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};

export const fetchMilestoneApprovedBudgetsAndCosts = (params: {
  project_id: string;
}): IBaseResponse<{ list: IDevBudgetDataDTO[] | null; }> => {
  return http({
    url: '/api/v1/globalpedia_pc/finance/key_milestone_budget_cost',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

export const fetchFinanceKeyMetricsV2 = (params: {
  project_id: string;
}): IBaseResponse<{ list: IDevBudgetDataDTO[] | null; }> => {
  return http({
    url: '/api/v1/globalpedia_pc/finance/key_metricsV2',
    method: 'GET',
    params,
    rawData: true,
  }) as any;
};

export const downloadMilestoneApprovedBudgetsAndCosts = (params: {
  project_id: string;
  file_type: string;
}) => {
  return http({
    url: '/api/v1/globalpedia_pc/finance/key_milestone_budget_cost_download',
    method: 'GET',
    params,
    original: true,
    responseType: 'blob',
    download: true,
    errorHandler: true,
  });
};
